var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.toolbar)?_c('toolbar'):_vm._e(),_c('v-main',{class:[{'full-background': _vm.fullBackground}]},[_c('waves',{on:{"show":function($event){_vm.needSpacer = $event}}}),_c('transition',{attrs:{"name":"main"}},[_c('router-view')],1),(_vm.needSpacer)?_c('spacer'):_vm._e()],1),_c('kimsa-toast')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }